import { tourProps as VCTourProps, tourStepProps as VCTourStepProps } from '../vc-tour';
import { functionType, someType } from '../_util/type';
import PropTypes from '../_util/vue-types';
export const tourProps = () => (Object.assign(Object.assign({}, VCTourProps()), { steps: { type: Array }, prefixCls: { type: String }, current: { type: Number }, type: { type: String }, 
    /** Custom action buttons (antd ≥ 5.25). */
    actionsRender: functionType(), 
    /** Customize close icon; `false` / `null` hides it (antd ≥ 5.9). */
    closeIcon: someType([Boolean, Object, String, Number, Function]), 'onUpdate:current': Function }));
export const tourStepProps = () => (Object.assign(Object.assign({}, VCTourStepProps()), { cover: { type: Object }, nextButtonProps: {
        type: Object,
    }, prevButtonProps: {
        type: Object,
    }, current: { type: Number }, type: { type: String }, 
    /** Custom action buttons (antd ≥ 5.25). */
    actionsRender: functionType(), 
    /** Customize close icon; `false` / `null` hides it (antd ≥ 5.9). */
    closeIcon: PropTypes.any }));
